import React from "react";
import {
  Grid,
  Paper,
  TextField
} from "@material-ui/core";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  DatePicker
} from "@material-ui/pickers";
import useStyles from "./styles";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { useQuery } from '@apollo/react-hooks';
import { GET_REPORT_BY_PUBLISHER_PAYMENT } from "../../../queries/reports";
import { GET } from "../../../queries/site";
import MUIDataTable from "mui-datatables";
import { UploadReceipt } from "./actions/upload";
import DrawerPlacements from "../../../components/DrawerPlacements";

let dataPayment = [];

function GetData(month, year){

  const { data } = useQuery(GET_REPORT_BY_PUBLISHER_PAYMENT, {
    variables: { month: month, year: year },
  });

  const { data:dataPublisher } = useQuery(GET);
  
  if(data && dataPublisher){
    dataPayment = data.reportByPublisherByRangeDatePayment;
    if(data.reportByPublisherByRangeDatePayment){
      const sites = dataPublisher.sites;
      data.reportByPublisherByRangeDatePayment.forEach(row => {
        var filteredSite = sites.filter((site)=> {
          return site.publisherId === row.publisherId;
        });
        if(filteredSite && filteredSite[0]){
          row.publisherName = filteredSite[0].name
        }
      });
    }
    dataPayment.sort((a,b) => (a.publisherName > b.publisherName) ? 1 : ((b.publisherName > a.publisherName) ? -1 : 0));
  }
}

export default function ReportPayments(props) {
  var classes = useStyles();
  const dateNow = new Date();
  const [dollar, setDollar] = React.useState(1);
  const [month, setMonth] = React.useState(dateNow.getMonth());
  const [year, setYear] = React.useState(dateNow.getFullYear());
  const [refDate, setRefDate] = React.useState(dateNow);
  const handleRefDateChange = value => 
  {
    const dateNew = new Date(value);
    setRefDate(dateNew);
    setMonth(dateNew.getMonth());
    setYear(dateNew.getFullYear());
  };
  const handleRefDollarChange = event => 
  {
    if(event && event.target)
      setDollar(event.target.value);
  };
  
  function uploadReceipt(tableMeta){
    const uploadReceipt = "Check Receipt";
    var publisherId = tableMeta.rowData[1];
    var publisherName = tableMeta.rowData[2];
    const referenceDate = `${month+1}/${year}`;
    
    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
        <DrawerPlacements title="Check Receipt" iconButtonAction={false} labeButtonAction={uploadReceipt}>
          <UploadReceipt publisherId={publisherId} publisherName={publisherName} referenceDate={referenceDate} USDValue={dollar}></UploadReceipt>
        </DrawerPlacements>
        </Grid>
        <Grid item xs={6}>
        </Grid>
      </Grid>
    );
  };

  GetData(month, year);

  return (
    <>
    <PageTitle title="Report by Publisher (Payment)"/>
    <br/>
    <Paper className={classes.paper}>
    <div>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
        views={["year", "month"]}
        label="Year and Month"
        value={refDate}
        onChange={handleRefDateChange}
        className={classes.margin}
        />
      </MuiPickersUtilsProvider>
      <TextField id="dollar" label="Dollar Value" color="primary" className={classes.margin}
      InputLabelProps={{ shrink : true, }} placeholder="Dollar"
      value={dollar}
      onChange={handleRefDollarChange}
      />
    </div>
    </Paper>
    <br />
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title={false}
            data={dataPayment}
            columns={[{
                name   : "id",
                options: {
                  display : false
                }
              },
              {
                name   : "publisherId",
                options: {
                  display : false
                }
              },
              {
                label : "Publisher Name",
                name    : 'publisherName',
                
              },
              {
                label : "Revenue",
                name    : 'revenue',
                options: {
                  customBodyRender: (value, tableMeta, updateValue) => { 
                    return (<>$ {value}</>);
                  }
                }
              },
              {
                label : "Revenue BRL",
                name    : 'revenue',
                options: {
                  customBodyRender: (value, tableMeta, updateValue) => { 
                    return (<>R$ {(isNaN(parseFloat(dollar)) ? value : (value * parseFloat(dollar)).toFixed(2))}</>);
                  }
                }
              },
              {
                label : "Check Receipt",
                name    : 'receiptAction',
                options: {
                  customBodyRender: (value, tableMeta, updateValue) => { 
                    return (uploadReceipt(tableMeta));
                  },
                  empty  : true,
                  filter : false,
                  sort   : false,
                }
              }
            ]}
            options={{
              customToolbarSelect: () => {},
              rowsPerPage: 100,
              selectableRows: 'none'
              
            }}
          />
        </Grid>
      </Grid>
      </Grid>
    </Grid>
    
    </>
  );
}